module.exports = __webpack_public_path__ + "img/logo.0dbf2a5a.png";